import { Injectable } from '@angular/core';
import { ServiceBase } from 'app/shared/serviceBase';
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BrokersModel } from '../models/brokers.model';
import { BrokerModelAdd } from '../models/broker-add.model';

@Injectable()
export class BrokersService extends ServiceBase {
    private commonUrl: string = this.url + '/Brokers/';
    constructor(
        private _http: HttpClient,
        private _authentication: AuthenticationService
    ) {
        super();
    }

    getAll(): Observable<BrokersModel[]> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .get<BrokersModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    getAllForCompany(companyId: string): Observable<BrokersModel[]> {
        const completeUrl: string = this.commonUrl + "company/" + companyId;
        return this._http
            .get<BrokersModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    create(model: BrokerModelAdd): Observable<string> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    deleteBroker(id: string): Observable<Response> {
        const completeUrl: string = this.commonUrl + id;
        return this._http.delete(completeUrl).pipe(
            map((response: Response) => response),
            catchError(this.handleError));
    }
}
